import { ResponsivePie } from "@nivo/pie";

function LegendlessDonutChart({ data, getTooltip, getLabel, getLabelsTextColor, CustomLayerComponent }) {
  return (
    <ResponsivePie
      data={data}
      margin={{ top: 10, right: 10, bottom: 10, left: 10 }}
      innerRadius={0.5}
      padAngle={0.9}
      colors={({data}) => data["color"]}
      cornerRadius={3}
      activeOuterRadiusOffset={8}
      tooltip={tooltipObj => getTooltip(tooltipObj)}
      borderWidth={1}
      borderColor={{
        from: 'color',
      }}
      enableArcLinkLabels={false}
      arcLabel={(el) => getLabel(el)}
      arcLabelsTextColor={el => getLabelsTextColor(el)}
      arcLabelsSkipAngle={10}
      layers={['arcs', 'arcLinkLabels', 'arcLabels', 'legends', CustomLayerComponent]}
    />
  )
}

export default LegendlessDonutChart;